{
  "#PMS_ROSTER": {
    "TITLE": "Roster Planner",
    "NEW_ENTRY": "New Entry",
    "NEW_ROSTER_ENTRY": "New Roster Entry",
    "PLAN_ENTRY": "Plan Entry",
    "APPOINTMENT": "Appointment",
    "REFRESH": "Refresh",
    "EDIT": "Edit",
    "DUPLICATE": "Duplicate",
    "COPY": "Copy",
    "DELETE": "Delete",
    "SAVE": "Save",
    "CREATE": "Create",
    "NEXT": "Next",
    "SEARCH": "Search...",
    "SELECTED": "selected",
    "VIEW": "View",
    "SELECTION": "Selection",
    "VIEW_TYPE": "Time Range",
    "COLUMN_WIDTH": "Column Width",
    "EVENT_TYPES": "Entry Types",
    "DETAILS": "Details",
    "VIEW_TYPE_DAY": "Day",
    "VIEW_TYPE_WEEK": "Week",
    "VIEW_TYPE_MONTH": "Month",
    "VIEW_TYPE_PLAN_MONTH": "Plan Allocation Month",
    "COLUMN_WIDTH_SMALL": "Narrow",
    "COLUMN_WIDTH_NORMAL": "Normal",
    "COLUMN_WIDTH_LARGE": "Wide",
    "DETAILS_COMPACT": "Compact",
    "DETAILS_ALL": "All Details",
    "FILTER_TICKETS_OBJECTS_TASKS": "Tickets, Objects, Tasks",
    "FILTER_APPOINTMENTS": "Calendar Entries (Appointments)",
    "FILTER_ABSENCES": "Absences (Vacation/Comp. Time)",
    "COPY_TICKET_NR": "Copy Ticket No.",
    "OPEN_TICKET": "Open Ticket",
    "COPY_OBJECT_NR": "Copy Object No.",
    "COPY_TO_NEXT_MONDAY": "Copy to next Monday",
    "CHANGE_STATUS": "Change Status",
    "STATUS_UNDEFINED": "Undefined",
    "STATUS_DONE": "Done",
    "STATUS_FORWARDED": "Forwarded",
    "STATUS_CHANGED_SUCCESS": "Status was changed successfully.",
    "WAS_CREATED": "was created.",
    "ENTRY_CREATED": "Roster entry was created.",
    "ENTRY_CREATE_ERROR": "Error creating the entry.",
    "NO_DEPARTMENT_HEADS": "No department heads found.",
    "DELETE_CONFIRM": "Do you want to delete this entry/entries?",
    "CREATE_ENTRY_TITLE": "Create New Roster Entry",
    "CREATE_ENTRY_SUBTITLE": "Enter the details for the new entry.",
    "EDIT_ENTRY_TITLE": "Edit Roster Entry",
    "EDIT_ENTRY_SUBTITLE": "Created by {{creatorUser}} on {{createdAt:'dd.MM.yyyy, HH:mm'}}",
    "DETAILS_SUBTITLE": "Set entry details",
    "CANCEL": "Cancel",
    "FORM": {
      "WHAT_TO_CREATE": "What would you like to create?",
      "CREATE_PLAN_ENTRY": "Create Plan Entry",
      "PLAN_ENTRY_DESC": "Can be linked to tickets or objects",
      "CREATE_APPOINTMENT": "Create Appointment",
      "APPOINTMENT_DESC": "Coming soon - With subject, location, description and participants",
      "SELECT_PARTICIPANTS": "Select Participants",
      "OTHER_DEPARTMENTS": "Other Departments",
      "SELECT_EMPLOYEE": "Select Employee",
      "CHOOSE_PARTICIPANTS": "Choose the participants",
      "CHOOSE_EMPLOYEE": "Choose the employee",
      "PARTICIPANTS_SELECTED": "participants selected",
      "ENTRY_TYPE": "Entry Type",
      "SELECT_ENTRY_TYPE": "Select entry type",
      "PARTICIPANT": "Participant",
      "EMPLOYEE": "Employee",
      "DATE_TIME": "Date & Time",
      "SET_DATE_TIME": "Set date and time",
      "TICKET_OBJECT": "Ticket/Object",
      "SUBJECT_DESCRIPTION": "Subject and Description",
      "LINK_ARTIFACT": "Link an artifact",
      "DATE": "Date",
      "START_TIME": "Start Time",
      "END_TIME": "End Time",
      "DURATION": "Duration",
      "SUBJECT": "Subject",
      "STATUS": "Status",
      "DESCRIPTION": "Description",
      "TICKET": "Ticket",
      "TICKET_NUMBER": "Ticket number",
      "TICKET_NOT_FOUND": "Ticket not found",
      "SEARCH_RESOURCES": "Search resources..."

    },
    "TASKS_LIST": {
      "TICKETS": "Tickets",
      "OBJECTS": "Objects",
      "STATUS": "Status",
      "PLANNED_NOT_FINISHED": "Planned, not completed",
      "ALL_OPEN": "All Open",
      "OPEN_WITH_TIME_TRACKING": "Open with Time Tracking",
      "OVERDUE": "Overdue",
      "FILTERED_BY_EMPLOYEES": "Filtered by employee(s):",
      "SEARCH_TICKETS": "Search tickets...",
      "NO_TICKETS_FOUND": "No tickets found",
      "LOADING_TICKETS": "Loading tickets...",
      "LOADING_TICKET": "Loading ticket...",
      "EXPAND_COLLAPSE_ALL": "Expand/collapse all tickets",
      "SORT_TICKET_NR": "Sort ticket no. ascending or descending",
      "REFRESH_TICKETS": "Reload tickets",
      "SEARCH_OBJECTS": "Search objects...",
      "NO_OBJECTS_FOUND": "No objects found",
      "LOADING_OBJECTS": "Loading objects...",
      "LOADING_OBJECT": "Loading object...",
      "SORT_OBJECT_NR": "Sort object no. ascending or descending",
      "REFRESH_OBJECTS": "Reload objects",
      "AL_COST_CENTERS": "AL Cost Centers",
      "PROJECT_LEADER": "Project Leader",
      "PARTICIPANT": "Participant"
    },
    "TICKET_CARD": {
      "SHOW_DETAILS": "Show details",
      "COPY_TICKET": "Copy ticket",
      "OPEN_TICKET_TAB": "Open ticket in new tab",
      "CREATED_ON": "Created on",
      "DUE_BY": "Due by",
      "LAST_PLANNED_ON": "Last planned on:"
    },
    "OBJECT_CARD": {
      "OBJECT": "Object"
    },
    "RESOURCE": {
      "OPEN": "open",
      "PLANNED_NOT_DONE": "planned, not completed",
      "TIME_COMPENSATION": "Comp.:"
    },
    "TIMELINE": {
      "NO_ENTRIES": "No entries for this day."
    },
    "APPOINTMENT_CARD": {
      "EMPTY_PLAN_ENTRY": "Empty Plan Entry",
      "EMPTY_APPOINTMENT": "Empty Appointment"
    },
    "EVENT": {
      "UNNAMED": "Unnamed"
    }
  }
}
